// extracted by css-extract-rspack-plugin
export default {"address":"ProfilePage_address__OjK3K","charityNumber":"ProfilePage_charityNumber__DsLZA","status":"ProfilePage_status__S45M9"};